import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ContractStopService {

	constructor(private _http: HttpClient) {
	}

	/**
	 * @api {post} /v2/ContractStops/AddressSearch Email Invoice
	 * @apiName checkIfMatchingContractStops
	 * @apiGroup ContractStops
	 * @apiVersion 20.1.0
	 */
	checkIfMatchingContractStops(data) {
		return this._http.post<any>(`${environment.apiUrl}/v2/ContractStops/AddressSearch`, data);
	}
}
